// ======================================================================
// File Name       : usageSettingLive
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ActionTypes from '../../../constants/actionTypes/usageSettingLive';

export function receivedLiveReservationTime(liveReservationTimeRes) {
  return {
    type: ActionTypes.RECEIVED_LIVE_RESERVATION_TIME,
    liveReservationTimeRes,
  };
}

export function receivedServiceInfo(serviceInfo) {
  return {
    type: ActionTypes.RECEIVED_SERVICE_INFO,
    serviceInfo,
  };
}

export function receivedLiveReservedList(
  { recordNum, liveList },
  userListToStore,
  liveUserCountList,
) {
  return {
    type: ActionTypes.RECEIVED_LIVE_RESERVED_LIST,
    recordNum,
    liveList,
    userListToStore,
    liveUserCountList,
  };
}

export function receivedLiveReservedDetail(
  liveReserveDetail,
  storedUserList,
  userLiveRelationList,
  userAttributeList,
  userLiveRecordedFileList,
) {
  return {
    type: ActionTypes.RECEIVED_LIVE_RESERVED_DETAIL,
    liveReserveDetail,
    storedUserList,
    userLiveRelationList,
    userAttributeList,
    userLiveRecordedFileList,
  };
}

export function addUsersToList(userListToAdd, storedUserList) {
  return {
    type: ActionTypes.ADD_USER_LIST_TO_LIVE,
    userListToAdd,
    storedUserList,
  };
}

export function removeUserFromList(userSecernId) {
  return {
    type: ActionTypes.REMOVE_USER_FROM_LIVE,
    userSecernId,
  };
}

export function saveLiveAuthorityIds(liveAuthorityIdList) {
  return {
    type: ActionTypes.SAVE_LIVE_AUTHORITY_IDS,
    liveAuthorityIdList,
  };
}

export function resetEdittingUsers() {
  return {
    type: ActionTypes.RESET_EDITING_LIVE_USERS,
  };
}

export function receiveJoinableLiveList(joinableLives) {
  return {
    type: ActionTypes.RECEIVE_JOINABLE_LIVE_LIST,
    joinableLives,
  };
}

// #7129 START
export function resetLiveReservedDetail() {
  return {
    type: ActionTypes.RESET_LIVE_RESERVED_DETAIL,
  };
}
// #7129 END
